<app-card-content [headerColor]="false" icon="pi pi-file" title="Protocolos" subtitle="Protocolos e tramitações do prestador">
    <app-custom-table
        [metadata]="metadataProtocolos"
        [data]="protocolos()"
        [columnOrder]="['ano', 'numero', 'tipoProtocolo', 'assunto', 'data', 'situacao', 'localizacao']"
        [loading]="carregandoProtocolos()"
        [first]="protocolosFirst()"
        [totalRecords]="protocolosTotalRecords()"
        [rows]="protocolosRows()"
        [showActions]="true"
        [showExpandButton]="true"
        [initialViewMode]="'table'"
        (onPageChange)="onPaginaProtocolosAlterada($event)"
    />

    <p-dialog
        appDialogoPadrao="pi pi-history"
        descricao="Andamento do protocolo no prestador."
        header="Tramitações"
        [visible]="dialogTramitacoesVisivel()"
        [style]="{ width: 'min(94vw, 1180px)' }"
        [breakpoints]="{ '960px': '94vw', '640px': '100vw' }"
        [appendTo]="'body'"
        (onHide)="fecharTramitacoes()"
    >
        @if (protocoloSelecionado(); as protocolo) {
            <p class="mb-4 text-sm text-muted-color">{{ protocolo.numero }}/{{ protocolo.ano }} - {{ protocolo.assunto }}</p>
        }
        <app-custom-table
            [metadata]="metadataTramitacoes"
            [data]="tramitacoesTabela()"
            [columnOrder]="['responsavel', 'dataTramitacao', 'dataConfirmacao', 'status', 'destino', 'origem', 'situacao']"
            [loading]="carregandoTramitacoes()"
            [first]="tramitacoesFirst()"
            [totalRecords]="tramitacoesTotalRecords()"
            [rows]="tramitacoesRows()"
            [showActions]="true"
            [showExpandButton]="true"
            [initialViewMode]="'table'"
            (onPageChange)="onPaginaTramitacoesAlterada($event)"
        />
    </p-dialog>

    <p-dialog
        appDialogoPadrao="pi pi-history"
        descricao="Parecer registrado na tramitação."
        header="Despacho"
        [visible]="dialogDespachoVisivel()"
        [style]="{ width: 'min(90vw, 760px)' }"
        [breakpoints]="{ '640px': '100vw' }"
        [appendTo]="'body'"
        (onHide)="fecharDespacho()"
    >
        @if (tramitacaoSelecionada(); as tramitacao) {
            <div class="rounded-lg border border-surface-200 p-4">
                <p class="whitespace-pre-wrap">{{ tramitacao.despacho || 'Nenhum despacho registrado.' }}</p>
            </div>
        }
    </p-dialog>
</app-card-content>
